import React, { useEffect } from 'react'
import AmritjalFooter from '../../components/Amritjal_hp/AmritjalFooter'
import HeroSection from '../../components/InflunencerHomepage/HeroSection'
import WhatweOffer from '../../components/Trip/WhatweOffer'
import Journey from '../../components/Trip/Journey'
import TripItinerary from '../../components/Trip/TripItinerary'
import trip_1_desktop from '../../assets/Explore/trip_1_desktop.jpeg';
import trip_2_desktop from '../../assets/Explore/trip_2_dv.jpeg';
import trip_1_mobile from '../../assets/Explore/trip_1_mobile.jpeg';
import trip_2_mobile from '../../assets/Explore/trip_2_mv.jpeg';
import WhatsAppSupport from '../../components/Support/WhatsAppSupport'
import TripCard from '../../components/Trip/TripCard'
import TripExclusion from '../../components/Trip/TripExclusion'
import Accordion from '../../components/Trip/Accordion'
import NavBar from '../../components/Navbar'

const TripHomePage = () => {
  useEffect(() => {
      window.scrollTo(0, 0); // Ensure scrolling to the top happens immediately
  
    }, []);
    
    const day1Items = [
      {
        title: '✨ Gathering in Delhi',
        time: '11:00 PM',
        description: 'Meet your tribe in Delhi 👫 (Get excited, share vibes, and prepare for the adventure ahead!)',
      },
      {
        title: '🌙 Midnight Road Trip Begins!',
        time: '12:00 AM',
        description: 'Hit the road for Rishikesh 🚗 (Epic travel tunes, great company, and road trip vibes all the way!)',
      },
      {
        title: '🌄 Sunrise Serenity at Neelkanth Temple',
        time: '7:00 AM',
        description: 'Arrive and head straight to Neelkanth Temple 🙏 (Experience the calm and spiritual energy of sunrise in the mountains.)',
      },
      {
        title: '💧 Hidden Waterfall Adventure',
        time: '10:00 AM',
        description: 'Discover a secret jungle waterfall 🌿 (Breathe in the fresh air, take a refreshing dip, and connect with nature.)',
      },
      {
        title: '🏕️ Check-in & Freshen Up',
        time: '12:00 PM',
        description: 'Check in at the resort 🌟 (Freshen up and get ready for the rest of the day’s adventure.)',
      },
      {
        title: '☕ Café Crawl & Chill',
        time: '2:00 PM - 5:00 PM',
        description: 'Hop between the coolest cafés in Rishikesh 🍕☕ (Savor delicious food and soak in the hippie vibes!)',
      },
      {
        title: '🕯️ Magical Ganga Aarti',
        time: '5:00 PM - 7:30 PM',
        description: 'Witness the mesmerizing Ganga Aarti at sunset 🙏 (Feel the spiritual essence of Rishikesh come alive!)',
      },
      {
        title: '🎉 Party at 12 Monks',
        time: '7:30 PM - 10:00 PM',
        description: 'Let loose and dance the night away 🕺💃 (Good music, great vibes, and new friends!)',
      },
      {
        title: '🌃 Explore or Unwind',
        time: '10:00 PM Onwards',
        description: 'Enjoy the night streets of Rishikesh 🌌 or relax back at the resort 🏕️ (Your night, your call!)',
      },
    ];
    
    const day2Items = [
      {
        title: '🌅 Sunrise by the Ganges',
        time: '5:00 AM',
        description: 'Wake up early for a sunrise like no other 🌄 (A peaceful and rejuvenating start to your day.)',
      },
      {
        title: '🧘‍♀️ Yoga by the Beach',
        time: '6:00 AM - 7:30 AM',
        description: 'Stretch, breathe, and flow by the Ganges with a professional instructor 🧘‍♂️ (Feel the serenity and positive energy of Rishikesh.)',
      },
      {
        title: '🚣‍♂️ White-Water Rafting Adventure!',
        time: '8:00 AM - 10:30 AM',
        description: 'Experience the thrill of rafting on the Ganges 🌊 (Adrenaline rush, epic views, and memories for a lifetime!)',
      },
      {
        title: '🌿 Relax & Checkout',
        time: '10:30 AM - 12:00 PM',
        description: 'Change, relax, and check out from the resort 🏕️ (Prepare for the day’s final adventures.)',
      },
      {
        title: '☕ Café Crawl & Sightseeing',
        time: '12:00 PM - 5:00 PM',
        description: 'Explore vibrant cafés, shop for souvenirs, and enjoy sightseeing on the other side of Laxman Jhula 🛍️✨.',
      },
      {
        title: '🚗 Farewell Rishikesh',
        time: '5:00 PM',
        description: 'Say goodbye to Rishikesh with unforgettable memories 🏙️ (Refreshed, recharged, and totally vibing!)',
      },
    ];
    

  return (
    <div>
      <NavBar/>
      <WhatsAppSupport/>
      <HeroSection/>
      <WhatweOffer/>
      <TripItinerary/>
    <Journey 
        title="DAY 1: Get Wild & Free in Rishikesh!" 
        timelineItems={day1Items} 
        desktopImageSrc={trip_1_desktop} 
        mobileImageSrc={trip_1_mobile} 
      />
      
      <Journey 
        title="Day 2: Find Your Flow & Inner Peace" 
        timelineItems={day2Items} 
        desktopImageSrc={trip_2_desktop} 
        mobileImageSrc={trip_2_mobile} 
      />
      <TripCard/>
      <TripExclusion/>
      <Accordion/>
      <AmritjalFooter/>
    </div>
  )
}

export default TripHomePage
